import React, { forwardRef } from "react";
import ReactCheckboxTree, { CheckboxProps } from "react-checkbox-tree";
import { CheckBox, CheckBoxOutlineBlank, IndeterminateCheckBox, KeyboardArrowDown, KeyboardArrowRight } from "@mui/icons-material";

import "react-checkbox-tree/lib/react-checkbox-tree.css";
import { Container } from "./CheckboxTree.styles";

const CheckboxTree = forwardRef<ReactCheckboxTree, CheckboxProps>(({ nodes, ...props }, ref) => {
  return (
    <Container>
      <ReactCheckboxTree
        ref={ref}
        nodes={nodes}
        icons={{
          check: <CheckBox className="checked" />,
          uncheck: <CheckBoxOutlineBlank className="unchecked" />,
          halfCheck: <IndeterminateCheckBox className="intermediate" />,
          collapseAll: <span className="rct-icon rct-icon-collapse-all" />,
          expandAll: <span className="rct-icon rct-icon-expand-all" />,
          expandClose: <KeyboardArrowRight fontSize="small" />,
          expandOpen: <KeyboardArrowDown fontSize="small" />,
        }}
        showNodeIcon={false}
        {...props}
      />
    </Container>
  );
});

CheckboxTree.displayName = "CheckboxTree";

export default CheckboxTree;
